var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('ApolloQuery',{attrs:{"query":_vm.seedsQuery},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var error = ref_result.error;
var data = ref_result.data;
return [_c('List',{attrs:{"listclass":"list__list","itemclass":"list__item","items":data.seeds},on:{"create":_vm.createNew,"delete":_vm.deleteItem}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }